//@flow
import { createSelector } from 'reselect';
import { clientSelector } from 'common/redux/selectors/queryParamsSelectors';

const OUTLET_ENTITY_TABLE_ID = 'OutletMaster';

class LocationGeocodeEditSelectors {
    getEntityTag = (_, props) => {
        return props.entity;
    };

    getGeocodeEditIdsData = createSelector(
        [
            state => state.locationGeocodeEdit,
            state => state.outletLocationGeocodeEdit,
            this.getEntityTag
        ],
        (locationGeocodeEditData, outletLocationGeocodeEditData, entity) => {
            if (entity === OUTLET_ENTITY_TABLE_ID) {
                return outletLocationGeocodeEditData;
            }
            return locationGeocodeEditData;
        }
    );

    getEditingEntityIds = createSelector(
        [this.getGeocodeEditIdsData, clientSelector],
        (geocodeEditIdsData, clientId) => {
            return geocodeEditIdsData.getIn([
                'records',
                clientId,
                'editingEntityIds'
            ]);
        }
    );

    getVerifyingEntityIds = createSelector(
        [this.getGeocodeEditIdsData, clientSelector],
        (geocodeEditIdsData, clientId) => {
            return geocodeEditIdsData.getIn([
                'records',
                clientId,
                'verifyingEntityIds'
            ]);
        }
    );

    getIsEditingLocation = createSelector(
        [(_, props) => props.locationEntity, this.getEditingEntityIds],
        (locationEntity, editingEntityIds) => {
            return locationEntity?.isEditInProgress(editingEntityIds);
        }
    );
    getIsVerifyingLocation = createSelector(
        [(_, props) => props.locationEntity, this.getVerifyingEntityIds],
        (locationEntity, verifyingEntityIds) => {
            return locationEntity?.isVerifyInProgress(verifyingEntityIds);
        }
    );
    getGroupedLocation = createSelector(
        [(_, props) => props.groupedLocation],
        groupedLocation => groupedLocation
    );
    getIsEditingLocationGroup = createSelector(
        [this.getGroupedLocation, this.getEditingEntityIds],
        (groupedLocation, editingEntityIds) => {
            return groupedLocation?.isEditInProgress(editingEntityIds);
        }
    );
    getIsVerifyingLocationGroup = createSelector(
        [this.getGroupedLocation, this.getVerifyingEntityIds],
        (groupedLocation, verifyingEntityIds) => {
            return groupedLocation?.isVerifyInProgress(verifyingEntityIds);
        }
    );
    getValidatingEntityIds = createSelector(
        [this.getGeocodeEditIdsData, clientSelector],
        (geocodeEditIdsData, clientId) => {
            return geocodeEditIdsData.getIn([
                'records',
                clientId,
                'validatingEntityIds'
            ]);
        }
    );
    getIsValidatingLocation = createSelector(
        [(_, props) => props.locationEntity, this.getValidatingEntityIds],
        (locationEntity, validatingEntityIds) => {
            return locationEntity?.isVerifyInProgress(validatingEntityIds);
        }
    );
    getValidatedGeometries = createSelector(
        [this.getGeocodeEditIdsData, clientSelector],
        (geocodeEditIdsData, clientId) => {
            return geocodeEditIdsData.getIn([
                'records',
                clientId,
                'geocodeValidatedGeometries'
            ]);
        }
    );
}

export default new LocationGeocodeEditSelectors();
